import type {ReactElement} from 'react';
import React from 'react';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {BaseTextOutlineOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-outline-option';
import type {TranscriptActiveWordOutlineOptionProps} from './transcript-active-word-outline-option.types';
import {SubtitleTemplateType} from '@PosterWhiteboard/items/transcript-item/subtitle/template-styles.types';
import {useGetKeyFromSubtitlePropertiesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitlePropertiesForTranscriptItem';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';

export function TranscriptActiveWordOutlineOption({...props}: TranscriptActiveWordOutlineOptionProps): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptActiveWordOutlineOption');
  }

  const animationStyle = useGetKeyFromSubtitlePropertiesForTranscriptItem('animationStyle');
  if (!animationStyle) {
    throw new Error('Transcript item does not have animationStyle property in its subtitle objects');
  }

  const stroke = useGetKeyFromSubtitleTextStylesForTranscriptItem('stroke', true);
  if (stroke === undefined) {
    throw new Error('Transcript item does not have stroke in activeWordTextStyles');
  }

  const strokeWidth = useGetKeyFromSubtitleTextStylesForTranscriptItem('strokeWidth', true);
  if (strokeWidth === undefined) {
    throw new Error('Transcript item does not have strokeWidth in activeWordTextStyles');
  }

  const strokeColor = useGetKeyFromSubtitleTextStylesForTranscriptItem('strokeColor', true);
  if (strokeColor === undefined) {
    throw new Error('Transcript item does not have strokeColor in activeWordTextStyles');
  }

  const onClickColorFill = (): void => {
    props.onActiveWordStrokeColorFillClick();
  };

  const onToggleOutlineOption = async (): Promise<void> => {
    await activeItem.updateAllSubtitlesStylesFromSubtitleObject({
      activeWordTextStyles: {
        stroke: !stroke,
      },
    });
  };

  const updateStrokeThickness = async (strokeWidth: number, undoable = true): Promise<void> => {
    await activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        activeWordTextStyles: {
          strokeWidth,
        },
      },
      {undoable}
    );
  };

  return (
    <BaseTextOutlineOption
      showNewTag={false}
      label={animationStyle === SubtitleTemplateType.PROGRESS ? window.i18next.t('pmwjs_highlight_words_outline') : window.i18next.t('pmwjs_highlight_word_outline')}
      stroke={stroke}
      isDisabled={false}
      strokeWidth={strokeWidth}
      strokeColor={strokeColor}
      onToggleOutlineOption={onToggleOutlineOption}
      updateStrokeThickness={updateStrokeThickness}
      onClickColorFill={onClickColorFill}
    />
  );
}
